/**
 * 
 */
(function collapsableMenuDirectiveDefinition() {

    'use strict';

    var styleSheetObject = null,
        styleSheetElement = null;

    function clearStyleSheet() {

        if (styleSheetElement !== null) {

            styleSheetElement.parentNode.removeChild(styleSheetElement);

            styleSheetObject = null;
            styleSheetElement = null;
        }
    }

    function createCssSelector(mediaQuery, selector, style, append) {

        if (!document.styleSheets) {
            return;
        }

        if (document.getElementsByTagName("head").length === 0) {
            return;
        }

        var styleSheet;

        if (styleSheetElement === null) {

            styleSheetElement = document.createElement("style");
            styleSheetElement.type = "text/css";
            styleSheetElement.media = "screen";

            document.getElementsByTagName("head")[0].appendChild(styleSheetElement);

            styleSheet = styleSheetObject = document.styleSheets[document.styleSheets.length - 1];
        } else {
            styleSheet = styleSheetObject;
        }

        var rules = styleSheet.rules;

        if (rules == null)
            rules = styleSheet.cssRules;

        if (!append) {
            for (var i = 0; i < rules.length; i++) {
                if (rules[i].cssText.indexOf(selector.toLowerCase()) !== -1) {
                    styleSheet.deleteRule(i);
                    break;
                }
            }
        }

        if (mediaQuery)
            styleSheet.insertRule(mediaQuery + ' { ' + selector + " {" + style + "}}", rules.length);
        else
            styleSheet.insertRule(selector + " {" + style + "}", rules.length);

    }

    angular.module('CollapsableMenu')
        .directive('collapsableMenu', [
            'config', '$timeout', '$parse', '$translate',
            function collapsableMenuDirective(config, $timeout, $parse, $translate) {
                return {
                    templateUrl: config.resourceUrl('/components/collapsable-menu/collapsable-menu.html'),
                    restrict: 'A',
                    requires: 'collapsableMenu',
                    scope: {
                        itemSelected: '&',
                        itemsList: '&collapsableMenu',
                        rightMargin: '=',
                        minItems: '=',
                        disableExpandWidth: '@'
                    },
                    controller: [
                        '$scope', '$element', '$attrs',
                        function collapsableMenuController($scope, $element, $attrs) {

                            var itemsCreated = 0;
                            var itemElements = {};
                            var rightMost = undefined;

                            $scope.$watch($scope.itemsList, function itemsChanged(value) {

                                itemsCreated = 0;
                                itemElements = {};
                                rightMost = undefined;

                                // Esto hace que se recreen los items y sus estilos.
                                // Realizo un copy para evitar que queden cacheados los elementos.
                                $scope.items = value.map(function(item) {
                                    return angular.copy(item);
                                });

                            });
                            
                            function createItemClasses() {

                                clearStyleSheet();

                                if ($scope.items == null || $scope.items.length === 0)
                                    return;

                                var left = 0, i = 0;

                                angular.forEach($scope.items, function (item) {

                                    var element = itemElements[item.menuId];
                                    var width = item.menuItemWidth;
                                    var right = left + width;

                                    if (rightMost === undefined || rightMost < right) {
                                        rightMost = right;
                                    }

                                    if ($scope.minItems && i < $scope.minItems) {
                                        left += width;
                                        i++;
                                        createCssSelector(null, '.menu-item-collapsed-' + item.menuId, 'display:none !important;');
                                        return;
                                    }

                                    if ($scope.disableExpandWidth) {
                                        createCssSelector('@media (max-width:' + (right + $scope.rightMargin) + 'px) and (min-width: ' + $scope.disableExpandWidth + ')', '.menu-item-not-collapsed-' + item.menuId, 'display:none !important;');                                        
                                    }
                                    else {
                                        createCssSelector('@media (max-width:' + (right + $scope.rightMargin) + 'px)', '.menu-item-not-collapsed-' + item.menuId, 'display:none !important;');
                                    }

                                    createCssSelector('@media (min-width:' + (right + $scope.rightMargin) + 'px)', '.menu-item-collapsed-' + item.menuId, 'display:none !important;');

                                    element.scope().class = 'menu-item-not-collapsed-' + item.menuId;

                                    left += width;
                                    i++;
                                });

                                if ($scope.minItems && i > $scope.minItems) {
                                    if ($scope.disableExpandWidth) {
                                        createCssSelector('@media (max-width:' + $scope.disableExpandWidth + ')', '.collapsable-menu', 'display:none !important;');
                                    }
                                    createCssSelector('@media (min-width:' + (rightMost + $scope.rightMargin) + 'px)', '.collapsable-menu', 'display:none !important;', true);
                                } else {
                                    createCssSelector(null, '.collapsable-menu', 'display:none !important;');
                                }
                            }

                            function translateItemsAndMeasure() {
                                var translatedCount = 0;

                                angular.forEach($scope.items, function (item) {

                                    $translate(item.text).then(function translated(text) {

                                        // Hago esto para medir porque sino cuando est� collapsed no funciona (el width es 0)
                                        // El float:left lo coloco porque sino tienen width 0 ya que tiene una media query en bootstrap.
                                        var measure = $('<nav class="navbar navbar-default" style="float:left;visibility:hidden;"><ul class="nav navbar-nav"><li><a href=""></a></li></ul></nav>');
                                        $('body').append(measure);
                                        var li = measure.find('li');
                                        var a = measure.find('a');
                                        a.text(text);
                                        item.menuItemWidth = li.width();
                                        measure.remove();
                                        translatedCount++;

                                        if (translatedCount === $scope.items.length)
                                            createItemClasses();
                                    });
                                });
                            }


                            this.itemCreated = function(item, element) {

                                item.menuId = element.id;

                                itemsCreated++;
                                itemElements[item.menuId] = element;

                                if (itemsCreated === $scope.items.length) {

                                    $timeout(function() {
                                        translateItemsAndMeasure();
                                    }, 1);
                                }

                            };

                            $scope.selected = function selected(item) {

                                var fn;
                                if ((fn = $scope.itemSelected)) {
                                    fn({ $item: item });
                                }

                            };

                        }
                    ],
                    // ReSharper disable once UnusedParameter
                    link: function($scope, $element, $attrs, ctrl) {

                    }
                };
            }
        ]);
})();